// extracted by mini-css-extract-plugin
export default {"wrapper":"status-module___wrapper___b183e093","tag":"status-module___tag___fa33edff"};